import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doctor-content" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6" }
const _hoisted_6 = { class: "col-lg-6 col-md-6" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "col-lg-4" }
const _hoisted_9 = { class: "col-lg-9" }
const _hoisted_10 = { class: "col-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoctorWelcome = _resolveComponent("DoctorWelcome")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_PatientRetentionChart = _resolveComponent("PatientRetentionChart")!
  const _component_PatientDistributionChart = _resolveComponent("PatientDistributionChart")!
  const _component_UpgradePlan = _resolveComponent("UpgradePlan")!
  const _component_IncomeExpenseChart = _resolveComponent("IncomeExpenseChart")!
  const _component_TodaySchedule = _resolveComponent("TodaySchedule")!
  const _component_MyRecentPatients = _resolveComponent("MyRecentPatients")!
  const _component_RecentLabReports = _resolveComponent("RecentLabReports")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DoctorWelcome),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Stats),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_PatientRetentionChart)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_PatientDistributionChart)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_UpgradePlan),
              _createVNode(_component_IncomeExpenseChart)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_TodaySchedule)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_MyRecentPatients)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_RecentLabReports)
        ])
      ])
    ])
  ], 64))
}